import React, { FC, memo } from 'react';

import Explore from './Explore';
import Resources from './Resources';
import SocialLinks from './SocialLinks';
import TopContent from './TopContent';
import Vaults from './Vaults';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const MobileMenu: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <TopContent onClose={onClose} />
      <Vaults onClose={onClose} />
      <Explore onClose={onClose} />
      <Resources onClose={onClose} />
      <SocialLinks onClose={onClose} />
    </div>
  );
};

export default memo(MobileMenu);
